var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "order-distribution-chart" }, [
    _c(
      "div",
      { staticClass: "chart-header" },
      [
        _c("h3", { staticClass: "chart-title" }, [_vm._v("订单数量分布")]),
        _c(
          "a-radio-group",
          {
            attrs: { "button-style": "solid", size: "small" },
            on: { change: _vm.handleTypeChange },
            model: {
              value: _vm.orderType,
              callback: function ($$v) {
                _vm.orderType = $$v
              },
              expression: "orderType",
            },
          },
          [
            _c("a-radio-button", { attrs: { value: "0" } }, [_vm._v("代收")]),
            _c("a-radio-button", { attrs: { value: "1" } }, [_vm._v("代付")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        ref: "chartContainer",
        staticClass: "chart-container",
        style: { height: "300px" },
      },
      [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "loading-container" },
              [
                _c("a-spin", {
                  attrs: { size: "large", tip: "图表加载中..." },
                }),
              ],
              1
            )
          : !_vm.hasData
          ? _c("div", { staticClass: "no-data-container" }, [
              _c("div", { staticClass: "no-data-text" }, [_vm._v("暂无数据")]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }